"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("./react");

var util_1 = require("./util");

var throttle_debounce_1 = require("throttle-debounce");

var defaultEvents = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel'];
var oneMinute = 60e3;

var useIdle = function useIdle() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oneMinute;
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEvents;

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  react_1.useEffect(function () {
    var mounted = true;
    var timeout;
    var localState = state;

    var set = function set(newState) {
      if (mounted) {
        localState = newState;
        setState(newState);
      }
    };

    var onEvent = throttle_debounce_1.throttle(50, function () {
      if (localState) {
        set(false);
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return set(true);
      }, ms);
    });

    var onVisibility = function onVisibility() {
      if (!document.hidden) onEvent();
    };

    for (var i = 0; i < events.length; i++) {
      util_1.on(window, events[i], onEvent);
    }

    util_1.on(document, 'visibilitychange', onVisibility);
    timeout = setTimeout(function () {
      return set(true);
    }, ms);
    return function () {
      mounted = false;

      for (var _i = 0; _i < events.length; _i++) {
        util_1.off(window, events[_i], onEvent);
      }

      util_1.off(document, 'visibilitychange', onVisibility);
    };
  }, events);
  return state;
};

exports.default = useIdle;